<template>
  <form class="guest-form" @submit.prevent="onSubmit">
    <!-- Anagrafica -->
    <div class="form-section">
      <h3 class="form-section__title">Anagrafica</h3>
      <div class="form-grid">
        <div class="form-field">
          <label>Nome <span class="required">*</span></label>
          <input v-model.trim="form.firstName" type="text" required />
        </div>
        <div class="form-field">
          <label>Cognome <span class="required">*</span></label>
          <input v-model.trim="form.lastName" type="text" required />
        </div>
        <div class="form-field">
          <label>Sesso <span v-if="isCreate" class="required">*</span></label>
          <select v-model="form.gender">
            <option value="">—</option>
            <option value="M">Maschio</option>
            <option value="F">Femmina</option>
          </select>
        </div>
        <div class="form-field">
          <label>
            Data di nascita <span v-if="isCreate" class="required">*</span>
          </label>
          <input v-model="form.birthDate" type="date" />
        </div>
        <div class="form-field">
          <label>
            Luogo di nascita <span v-if="isCreate" class="required">*</span>
          </label>
          <input v-model.trim="form.birthPlace" type="text" />
        </div>
        <div class="form-field">
          <label>
            Provincia di nascita
            <span v-if="isCreate" class="required">*</span>
          </label>
          <input
            v-model.trim="form.birthProvince"
            type="text"
            maxlength="4"
            placeholder="es. PA"
          />
        </div>
        <div class="form-field">
          <label>Codice fiscale</label>
          <input v-model.trim="form.taxCode" type="text" />
        </div>
      </div>
    </div>

    <!-- Residenza -->
    <div class="form-section">
      <h3 class="form-section__title">Residenza</h3>
      <div class="form-grid">
        <div class="form-field form-field--full">
          <label>
            Indirizzo <span v-if="isCreate" class="required">*</span>
          </label>
          <input v-model.trim="form.address" type="text" />
        </div>
        <div class="form-field">
          <label>Città <span v-if="isCreate" class="required">*</span></label>
          <input v-model.trim="form.city" type="text" />
        </div>
        <div class="form-field">
          <label>CAP</label>
          <input v-model.trim="form.zip" type="text" />
        </div>
        <div class="form-field">
          <label>
            Provincia <span v-if="isCreate" class="required">*</span>
          </label>
          <input v-model.trim="form.province" type="text" maxlength="4" />
        </div>
        <div class="form-field">
          <label>Telefono</label>
          <input v-model.trim="form.phone" type="text" />
        </div>
      </div>
    </div>

    <!-- Documento d'identità -->
    <div class="form-section">
      <h3 class="form-section__title">Documento d'identità</h3>
      <div class="form-grid">
        <div class="form-field">
          <label>Tipo documento</label>
          <input
            v-model.trim="form.identityDocumentType"
            type="text"
            placeholder="es. Carta d'identità"
          />
        </div>
        <div class="form-field">
          <label>Numero documento</label>
          <input v-model.trim="form.identityDocumentNumber" type="text" />
        </div>
        <div class="form-field">
          <label>Rilasciato da</label>
          <input v-model.trim="form.identityDocumentIssuedBy" type="text" />
        </div>
        <div class="form-field">
          <label>Data rilascio</label>
          <input v-model="form.identityDocumentIssueDate" type="date" />
        </div>
        <div class="form-field">
          <label>Data scadenza</label>
          <input v-model="form.identityDocumentExpiryDate" type="date" />
        </div>
      </div>
    </div>

    <!-- Responsabile / coobbligato -->
    <div class="form-section">
      <h3 class="form-section__title">Responsabile / coobbligato</h3>
      <div class="form-grid">
        <div class="form-field">
          <label>Nome</label>
          <input v-model.trim="form.responsibleFirstName" type="text" />
        </div>
        <div class="form-field">
          <label>Cognome</label>
          <input v-model.trim="form.responsibleLastName" type="text" />
        </div>
        <div class="form-field">
          <label>Relazione con l'ospite</label>
          <input
            v-model.trim="form.responsibleRelationship"
            type="text"
            placeholder="es. Figlio/a"
          />
        </div>
        <div class="form-field">
          <label>Telefono</label>
          <input v-model.trim="form.responsiblePhone" type="text" />
        </div>
        <div class="form-field">
          <label>Email</label>
          <input v-model.trim="form.responsibleEmail" type="email" />
        </div>
        <div class="form-field">
          <label>Codice fiscale</label>
          <input v-model.trim="form.responsibleTaxCode" type="text" />
        </div>
        <div class="form-field form-field--full">
          <label>Indirizzo residenza</label>
          <input v-model.trim="form.responsibleResidenceAddress" type="text" />
        </div>
        <div class="form-field">
          <label>Città</label>
          <input v-model.trim="form.responsibleResidenceCity" type="text" />
        </div>
        <div class="form-field">
          <label>Provincia</label>
          <input
            v-model.trim="form.responsibleResidenceProvince"
            type="text"
            maxlength="4"
          />
        </div>
        <div class="form-field">
          <label>CAP</label>
          <input v-model.trim="form.responsibleResidenceZip" type="text" />
        </div>
      </div>
    </div>

    <!-- Contatto familiare -->
    <div class="form-section">
      <h3 class="form-section__title">Contatto familiare di riferimento</h3>
      <div class="form-grid">
        <div class="form-field">
          <label>Nome e cognome</label>
          <input v-model.trim="form.familyContactName" type="text" />
        </div>
        <div class="form-field">
          <label>Parentela</label>
          <input v-model.trim="form.familyContactRelationship" type="text" />
        </div>
        <div class="form-field">
          <label>Telefono</label>
          <input v-model.trim="form.familyContactPhone" type="text" />
        </div>
        <div class="form-field">
          <label>Email</label>
          <input v-model.trim="form.familyContactEmail" type="email" />
        </div>
      </div>
    </div>

    <!-- Medico di base -->
    <div class="form-section">
      <h3 class="form-section__title">Medico di base</h3>
      <div class="form-grid">
        <div class="form-field">
          <label>Nome</label>
          <input v-model.trim="form.generalPractitionerName" type="text" />
        </div>
        <div class="form-field">
          <label>Telefono</label>
          <input v-model.trim="form.generalPractitionerPhone" type="text" />
        </div>
      </div>
    </div>

    <!-- Ingresso e dati economici -->
    <div class="form-section">
      <h3 class="form-section__title">Ingresso e dati economici</h3>
      <div class="form-grid">
        <div class="form-field">
          <label>Struttura</label>
          <input
            v-if="lockedFacilityId != null"
            type="text"
            :value="lockedFacilityName || 'Struttura selezionata'"
            disabled
          />
          <select v-else v-model="form.facilityId">
            <option :value="null">Nessuna struttura assegnata</option>
            <option v-for="f in facilities" :key="f.id" :value="f.id">
              {{ f.name }}
            </option>
          </select>
        </div>
        <div class="form-field">
          <label>
            Data di ingresso <span v-if="isCreate" class="required">*</span>
          </label>
          <input v-model="form.admissionDate" type="date" />
        </div>
        <div class="form-field">
          <label>Data di dimissione</label>
          <input v-model="form.dischargeDate" type="date" />
        </div>
        <div class="form-field">
          <label>Stato</label>
          <select v-model="form.status">
            <option
              v-for="opt in statusOptions"
              :key="opt.value"
              :value="opt.value"
            >
              {{ opt.label }}
            </option>
          </select>
        </div>
        <div class="form-field">
          <label>
            Retta mensile (€) <span v-if="isCreate" class="required">*</span>
          </label>
          <input
            v-model="form.monthlyFee"
            type="number"
            min="0"
            step="0.01"
            placeholder="es. 1250.00"
          />
        </div>
      </div>
    </div>

    <!-- Note -->
    <div class="form-section">
      <h3 class="form-section__title">Note</h3>
      <div class="form-grid">
        <div class="form-field form-field--full">
          <label>Annotazioni</label>
          <textarea v-model.trim="form.notes" rows="3"></textarea>
        </div>
      </div>
    </div>

    <div class="form-actions">
      <button
        type="button"
        class="villa-btn villa-btn--ghost"
        @click="$emit('cancel')"
      >
        Annulla
      </button>
      <button
        type="submit"
        class="villa-btn villa-btn--primary"
        :disabled="submitting"
      >
        <i v-if="submitting" class="fa-solid fa-spinner fa-spin"></i>
        {{ submitting ? "Salvataggio…" : submitLabel }}
      </button>
    </div>
  </form>
</template>

<script>
import { mapActions } from "vuex";

const emptyGuest = () => ({
  firstName: "",
  lastName: "",
  facilityId: null,
  gender: "",
  birthDate: "",
  birthPlace: "",
  birthProvince: "",
  taxCode: "",
  address: "",
  city: "",
  zip: "",
  province: "",
  phone: "",
  admissionDate: "",
  dischargeDate: "",
  status: "active",
  monthlyFee: "",
  // Documento d'identità (D7)
  identityDocumentType: "",
  identityDocumentNumber: "",
  identityDocumentIssuedBy: "",
  identityDocumentIssueDate: "",
  identityDocumentExpiryDate: "",
  // Responsabile / coobbligato (D7)
  responsibleFirstName: "",
  responsibleLastName: "",
  responsibleRelationship: "",
  responsiblePhone: "",
  responsibleEmail: "",
  responsibleTaxCode: "",
  responsibleResidenceAddress: "",
  responsibleResidenceCity: "",
  responsibleResidenceProvince: "",
  responsibleResidenceZip: "",
  familyContactName: "",
  familyContactRelationship: "",
  familyContactPhone: "",
  familyContactEmail: "",
  generalPractitionerName: "",
  generalPractitionerPhone: "",
  notes: "",
});

// Campi obbligatori in CREAZIONE (D9): anagrafica minima richiesta dal contratto.
// In modifica non sono imposti (non si rompono ospiti pre-esistenti).
const REQUIRED_CREATE_FIELDS = [
  ["firstName", "Nome"],
  ["lastName", "Cognome"],
  ["gender", "Sesso"],
  ["birthDate", "Data di nascita"],
  ["birthPlace", "Luogo di nascita"],
  ["birthProvince", "Provincia di nascita"],
  ["city", "Città di residenza"],
  ["province", "Provincia di residenza"],
  ["address", "Indirizzo di residenza"],
  ["admissionDate", "Data di ingresso"],
  ["monthlyFee", "Retta mensile"],
];

// Tutti i campi data del form (vuoto -> null lato submit/hydrate).
const DATE_FIELDS = [
  "birthDate",
  "admissionDate",
  "dischargeDate",
  "identityDocumentIssueDate",
  "identityDocumentExpiryDate",
];

export default {
  name: "GuestForm",
  props: {
    // Valori iniziali (per la modifica). Se null -> form vuoto (creazione).
    initial: { type: Object, default: null },
    submitting: { type: Boolean, default: false },
    submitLabel: { type: String, default: "Salva" },
    // Contesto struttura (D6C-ARCH): se valorizzato, l'ospite viene creato/
    // modificato sempre dentro questa struttura e la select è sostituita da un
    // campo read-only.
    lockedFacilityId: { type: [Number, String], default: null },
    lockedFacilityName: { type: String, default: "" },
  },
  emits: ["submit", "cancel"],
  data() {
    return {
      form: emptyGuest(),
      facilities: [],
      statusOptions: [
        { value: "active", label: "Attivo" },
        { value: "discharged", label: "Dimesso" },
        { value: "suspended", label: "Sospeso" },
        { value: "deceased", label: "Deceduto" },
      ],
    };
  },
  computed: {
    // Creazione = nessun valore iniziale. In creazione i campi del contratto
    // sono obbligatori; in modifica no.
    isCreate() {
      return this.initial == null;
    },
  },
  watch: {
    initial: {
      immediate: true,
      handler(val) {
        if (val) this.hydrate(val);
        else this.enforceLock();
      },
    },
  },
  created() {
    this.enforceLock();
  },
  mounted() {
    this.loadFacilities();
  },
  methods: {
    ...mapActions(["fetchFacilities"]),
    async loadFacilities() {
      try {
        this.facilities = await this.fetchFacilities();
      } catch {
        this.facilities = [];
      }
    },
    hydrate(val) {
      const base = emptyGuest();
      // Copia solo i campi noti; le date possono arrivare come ISO -> tieni YYYY-MM-DD
      for (const key of Object.keys(base)) {
        if (val[key] === null || val[key] === undefined) continue;
        if (DATE_FIELDS.includes(key)) {
          base[key] = String(val[key]).slice(0, 10);
        } else {
          base[key] = val[key];
        }
      }
      this.form = base;
      this.enforceLock();
    },
    // Forza la struttura quando il form è usato in contesto struttura.
    enforceLock() {
      if (this.lockedFacilityId != null) {
        this.form.facilityId = Number(this.lockedFacilityId);
      }
    },
    // Valida i campi obbligatori in creazione (D9). Ritorna l'elenco mancanti.
    missingRequired() {
      const missing = [];
      for (const [field, label] of REQUIRED_CREATE_FIELDS) {
        if (field === "monthlyFee") {
          const v = this.form.monthlyFee;
          const n = Number(v);
          if (v === "" || v === null || v === undefined || !(n > 0)) {
            missing.push(label);
          }
          continue;
        }
        if (!String(this.form[field] ?? "").trim()) missing.push(label);
      }
      return missing;
    },
    onSubmit() {
      // In creazione blocca con messaggio leggibile se mancano campi del contratto.
      if (this.isCreate) {
        const missing = this.missingRequired();
        if (missing.length) {
          this.$toast.error(
            `Compila i campi obbligatori: ${missing.join(", ")}.`
          );
          return;
        }
      }
      // Città: evita sigle/abbreviazioni (es. "CT", "MI"). Se valorizzata con
      // 1–2 caratteri, chiedi il nome completo (fix review 0.1).
      const cityVal = String(this.form.city ?? "").trim();
      if (cityVal.length >= 1 && cityVal.length <= 2) {
        this.$toast.error("Digita il nome completo della città");
        return;
      }
      // Luogo di nascita (comune): niente abbreviazioni. Stesso criterio della
      // città. La provincia di nascita resta invece una sigla (non validata qui).
      const birthPlaceVal = String(this.form.birthPlace ?? "").trim();
      if (birthPlaceVal.length >= 1 && birthPlaceVal.length <= 2) {
        this.$toast.error(
          "Digita il nome completo del luogo di nascita (senza abbreviazioni)"
        );
        return;
      }
      // Invia una copia: le stringhe vuote restano tali (il backend le accetta);
      // le date vuote vanno inviate come null per non rompere il tipo DATEONLY.
      const payload = { ...this.form };
      for (const k of DATE_FIELDS) {
        if (!payload[k]) payload[k] = null;
      }
      // Retta mensile vuota -> null (ospite "non valorizzato").
      if (payload.monthlyFee === "" || payload.monthlyFee === undefined) {
        payload.monthlyFee = null;
      }
      if (this.lockedFacilityId != null) {
        payload.facilityId = Number(this.lockedFacilityId);
      }
      this.$emit("submit", payload);
    },
  },
};
</script>

<style src="@/css/GuestsPage.css" />
